import ExamLayout from './ExamLayout';
import ExamResumeScreen from './ExamResumeScreen';
import ExamRulesScreen from './ExamRulesScreen';
import ExamFinishedScreen from './ExamFinishedScreen';
import ExamQuestionScreen from './ExamQuestionScreen';
import ExamLoadingScreen from './ExamLoadingScreen';
import ExamErrorScreen from './ExamErrorScreen';
import ExamAccessIssueScreen from './ExamAccessIssueScreen';
import { useAllProgress } from '../../userProgress';
import { useMostRecentExamAttempt } from '../examsQueries';
import { useCanDoAllTrackPracticalExercises } from '../../tracks';
import { useExamRulesState, withExamContextProvider } from '../examsStores';
import { useState } from 'react';
import ExamLinkedLanguage from './ExamLinkedLanguage';
import { jsx as _jsx } from "react/jsx-runtime";
const Exam = ({
  trackId: maybeStringTrackId,
  language
}) => {
  var _trackProgress$award, _allProgress$assetPro;
  const {
    showExamRules
  } = useExamRulesState();
  const {
    allProgress,
    allProgressLoading,
    allProgressError
  } = useAllProgress({
    language
  }, {
    timeout: 20000
  });
  const trackId = Number(maybeStringTrackId);
  const trackProgress = allProgress.assetProgress.find(asset => asset.type === 'TRACK' && asset.id === trackId);
  const trackAwardId = trackProgress === null || trackProgress === void 0 || (_trackProgress$award = trackProgress.award) === null || _trackProgress$award === void 0 ? void 0 : _trackProgress$award.trackIdAward;
  const certificationAwardedInDifferentLanguage = trackAwardId && trackAwardId !== trackId;
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(trackId, language);
  const {
    canDoAllTrackPracticalExercises,
    canDoAllTrackPracticalExercisesLoading,
    canDoAllTrackPractcialExercisesError
  } = useCanDoAllTrackPracticalExercises(trackId.toString(), language);
  const [examStartedAt, setExamStartedAt] = useState(null);
  const isLoadingCombined = mostRecentExamAttemptLoading || canDoAllTrackPracticalExercisesLoading || allProgressLoading;
  const errorCombined = mostRecentExamAttemptError || canDoAllTrackPractcialExercisesError || allProgressError;
  const linkedLanguage = (_allProgress$assetPro = allProgress.assetProgress.find(asset => asset.type === 'TRACK' && asset.id === trackAwardId)) === null || _allProgress$assetPro === void 0 ? void 0 : _allProgress$assetPro.language;
  if (isLoadingCombined) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamLoadingScreen, {})
    });
  }
  if (errorCombined) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamErrorScreen, {
        error: errorCombined
      })
    });
  }
  if (!canDoAllTrackPracticalExercises) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamAccessIssueScreen, {})
    });
  }
  const examNotCompletedInAnyLanguage = !mostRecentExamAttempt && !certificationAwardedInDifferentLanguage;
  if (examNotCompletedInAnyLanguage || showExamRules) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamRulesScreen, {
        language: language,
        onExamStart: () => setExamStartedAt(new Date().getTime()),
        trackId: trackId
      })
    });
  }
  const hasResumeableExam = mostRecentExamAttempt && (mostRecentExamAttempt === null || mostRecentExamAttempt === void 0 ? void 0 : mostRecentExamAttempt.attemptFinishTime) == null;
  if (linkedLanguage && certificationAwardedInDifferentLanguage && !examStartedAt && !hasResumeableExam) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamLinkedLanguage, {
        language: language,
        linkedLanguage: linkedLanguage,
        trackAwardId: trackAwardId,
        trackId: trackId
      })
    });
  }
  if (mostRecentExamAttempt && mostRecentExamAttempt.finished) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamFinishedScreen, {
        certificationAwardedInDifferentLanguage: !!certificationAwardedInDifferentLanguage,
        language: language,
        trackId: trackId
      })
    });
  }
  if (mostRecentExamAttempt && !mostRecentExamAttempt.questions.length) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamResumeScreen, {
        language: language,
        trackId: trackId
      })
    });
  }
  return /*#__PURE__*/_jsx(ExamLayout, {
    children: /*#__PURE__*/_jsx(ExamQuestionScreen, {
      clientStartTime: examStartedAt,
      language: language,
      trackId: trackId
    })
  });
};
export default withExamContextProvider(Exam);